import { Typography } from "@material-ui/core";

const TextFieldWithAny = ({ source, record }) => {
  return <Typography>{record[source] ? record[source] : "Any"}</Typography>;
};

export default TextFieldWithAny;
